import { newsletterUnsubscribeResultSchema } from '@koderek/shared';
import { Alert, Loader, Stack, Title } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { api, ApiError } from '../api/client';
import { ErrorAlert } from '../components/ErrorAlert';
import { t } from '../texts/pl';

const n = t.newsletter;

/**
 * US-705 AC-3: link „Wypisz się z newslettera” z maila – jedno kliknięcie wycofuje zgodę, bez logowania
 * (adres musi zgadzać się z `apps/api/src/communication/newsletter.service.ts`).
 */
export function NewsletterUnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const unsubscribe = useMutation({
    mutationFn: () =>
      api('POST', `/newsletter/unsubscribe?token=${encodeURIComponent(token)}`, { schema: newsletterUnsubscribeResultSchema }),
  });
  const { mutate } = unsubscribe;
  useEffect(() => {
    if (token) mutate();
  }, [token, mutate]);

  const invalid = !token || (unsubscribe.error instanceof ApiError && unsubscribe.error.code === 'token_invalid');
  return (
    <Stack gap="md" maw={560}>
      <Title order={1}>{n.title}</Title>
      {invalid ? (
        <Alert color="orange">{n.invalid}</Alert>
      ) : unsubscribe.isError ? (
        <ErrorAlert error={unsubscribe.error} />
      ) : unsubscribe.data ? (
        <Alert color="green" role="status">
          {unsubscribe.data.result === 'unsubscribed' ? n.unsubscribed : n.already}
        </Alert>
      ) : (
        <Loader size="sm" aria-label={n.working} />
      )}
    </Stack>
  );
}
